import { useCallback } from "react";
import { DnaTestTracker } from "../../../utils/api-objects/DnaTestTracker";
import {
    ErrorWithMessageCallback,
} from "../../../utils/apis/callback-helpers";
import { updateTrackerByOrderId } from "../../../utils/apis/tracker-service";
import { useAuth } from "../../../utils/context/AuthContext";
import { TrackingStatus } from "../../../utils/Enums";

export function useUpdateDnaTrackerByOrderId() {
    const { auth } = useAuth();
    const idToken = auth.idToken;

    return useCallback(
        (
            orderId: string,
            status: TrackingStatus,
            onSuccess: (tracker: DnaTestTracker) => void,
            onError: ErrorWithMessageCallback
        ) => {
            if (!idToken) {
                onError("Token mancante");
                return;
            }

            updateTrackerByOrderId(
                orderId,
                idToken,
                status,
                onSuccess,
                onError
            );
        },
        [idToken]
    );
}